import { Controller } from "@hotwired/stimulus"
import List from "list.js"

// Connects to data-controller="table"
export default class extends Controller {
  // Override list.js default search because we don't want to escape chars like . and -
  connect() {
    const options = {
      valueNames: this.valueNames(),
      searchClass: null   // disable automatic binding
    }

    this.list = new List(this.element, options)

    this.searchInput = this.element.querySelector(".search")

    this.searchInput.addEventListener("input", e => {
      this.literalSearch(e.target.value)
    })
  }

  literalSearch(query) {
    const q = query.trim().toLowerCase()

    this.list.items.forEach(item => {
      const values = Object.values(item.values()).join(" ").toLowerCase()

      item.elm.style.display =
          q === "" || values.includes(q)
              ? ""
              : "none"
    })
  }

  valueNames() {
    return this.data.get("values").split(",").map(v => v.trim())
  }
}